import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import type { TemplateTab } from '../types/TemplateTabs';

const TEMPLATE_TABS_BLOCKS_FIRST: DevelopmentTool[] = [
  DevelopmentTool.BLOCKS,
  DevelopmentTool.CLI,
  DevelopmentTool.DEV_CENTER,
];

const TEMPLATE_TABS_BLOCKS_LAST: DevelopmentTool[] = [
  DevelopmentTool.CLI,
  DevelopmentTool.DEV_CENTER,
  DevelopmentTool.BLOCKS,
];

export enum SideBarItemType {
  HEADING = 'heading',
  TEMPLATE_TAB = 'template-tab',
}

export interface ISideBarItem {
  id: TemplateTab | string;
  type: SideBarItemType;
  sideBarItemKey: string;
  gridTitleKey?: string;
  gridSubtitleKey?: string;
  gridDocsKey?: string;
  badgeTextKey?: string;
}

const SIDEBAR_ITEMS_BLOCKS_FIRST: ISideBarItem[] = [
  {
    id: 'developer-tools',
    type: SideBarItemType.HEADING,
    sideBarItemKey: 'app.sidebar.developer-tools',
  },
  {
    id: DevelopmentTool.BLOCKS,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.wix-blocks',
    gridTitleKey: 'app.grid.title.blocks',
    gridSubtitleKey: 'app.grid.subtitle.blocks',
    gridDocsKey: 'app.grid.docs.blocks',
    badgeTextKey: 'app.badge.wix-blocks',
  },
  {
    id: DevelopmentTool.CLI,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.wix-cli',
    gridTitleKey: 'app.grid.title.cli',
    gridSubtitleKey: 'app.grid.subtitle.cli',
    gridDocsKey: 'app.grid.docs.cli',
    badgeTextKey: 'app.badge.wix-cli',
  },
  {
    id: DevelopmentTool.DEV_CENTER,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.dev-center',
    gridTitleKey: 'app.grid.title.dev-center',
    gridSubtitleKey: 'app.grid.subtitle.dev-center',
    gridDocsKey: 'app.grid.docs.dev-center',
    badgeTextKey: 'app.badge.dev-center',
  },
];

// Export for mappers - order doesn't matter for lookup tables
export const ALL_SIDEBAR_ITEMS = SIDEBAR_ITEMS_BLOCKS_FIRST;

const SIDEBAR_ITEMS_BLOCKS_LAST: ISideBarItem[] = [
  {
    id: 'developer-tools',
    type: SideBarItemType.HEADING,
    sideBarItemKey: 'app.sidebar.developer-tools',
  },
  {
    id: DevelopmentTool.CLI,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.wix-cli',
    gridTitleKey: 'app.grid.title.cli',
    gridSubtitleKey: 'app.grid.subtitle.cli',
    gridDocsKey: 'app.grid.docs.cli',
    badgeTextKey: 'app.badge.wix-cli',
  },
  {
    id: DevelopmentTool.DEV_CENTER,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.dev-center',
    gridTitleKey: 'app.grid.title.dev-center',
    gridSubtitleKey: 'app.grid.subtitle.dev-center',
    gridDocsKey: 'app.grid.docs.dev-center',
    badgeTextKey: 'app.badge.dev-center',
  },
  {
    id: DevelopmentTool.BLOCKS,
    type: SideBarItemType.TEMPLATE_TAB,
    sideBarItemKey: 'app.wix-blocks',
    gridTitleKey: 'app.grid.title.blocks',
    gridSubtitleKey: 'app.grid.subtitle.blocks',
    gridDocsKey: 'app.grid.docs.blocks',
    badgeTextKey: 'app.badge.wix-blocks',
  },
];

export const getSidebarItems = (displayHarmonyNotifications: boolean) =>
  displayHarmonyNotifications
    ? SIDEBAR_ITEMS_BLOCKS_LAST
    : SIDEBAR_ITEMS_BLOCKS_FIRST;

export const getTemplateTabs = (displayHarmonyNotifications: boolean) =>
  displayHarmonyNotifications
    ? TEMPLATE_TABS_BLOCKS_LAST
    : TEMPLATE_TABS_BLOCKS_FIRST;
